import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import './Backgrounds.css';
import { apiFetch } from '../api/api'; // <-- Import your helper

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError('Please enter both email and password.');
      return;
    }

    try {
      const data = await apiFetch('/api/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      });

      setError('');
      localStorage.setItem('token', data.token);
      localStorage.setItem('isLoggedIn', 'true');
      alert('Logged in!');
      navigate('/');
    } catch (err) {
      setError(err.message || 'Login failed.');
    }
  };

  const handleRegisterRedirect = () => {
    navigate('/register');
  };

  const handleForgotPasswordRedirect = () => {
    navigate('/forgot-password');
  };

  return (
    <div className="login-container">
      <form onSubmit={handleLogin} className="login-form">
        <h2>Welcome to Virtual Garage</h2>
        {error && <p className="error">{error}</p>}
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Login</button>
        <button
          type="button"
          className="register-btn"
          onClick={handleRegisterRedirect}
          style={{ marginTop: '12px' }}
        >
          Register
        </button>
        <button
          type="button"
          className="forgot-password-btn"
          onClick={handleForgotPasswordRedirect}
          style={{ marginTop: '12px' }}
        >
          Forgot Password?
        </button>
      </form>
    </div>
  );
};

export default Login;
